import {
  Create,
  Datagrid,
  DateField,
  Edit,
  ImageField,
  List,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  NumberInput
} from 'react-admin';
import { FilterSidebar } from '../components/FilterSidebar';
import { ImageInput } from '../components/ImageInput';
import gql from 'graphql-tag';

export const name = 'Instructor';
export const fragments = {
  type: 'document',
  doc: gql`
    fragment FragInstructors on instructors {
      id
      bio
      imageUrl
      name
      order
      createdAt
      updatedAt
      _count {
        exercises
        programs
        workouts
        __typename
      }
      __typename
    }
  `
};

const list = () => (
  <List aside={<FilterSidebar />} sort={{ field: 'name', order: 'ASC' }}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="bio" />
      <ImageField source="imageUrl" />
      <TextField source="order" />
    </Datagrid>
  </List>
);

const show = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="bio" />
      <ImageField source="imageUrl" />
      <TextField source="order" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

const edit = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="name" />
      <TextInput source="bio" multiline fullWidth />
      <ImageInput source="imageUrl" />
      <NumberInput source="order" />
    </SimpleForm>
  </Edit>
);

const create = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="bio" multiline fullWidth />
      <ImageInput source="imageUrl" />
      <NumberInput source="order" />
    </SimpleForm>
  </Create>
);

export default function AdminResource(props) {
  return (
    <Resource
      create={create}
      edit={edit}
      list={list}
      name={name}
      show={show}
      {...props}
    />
  );
}
